export enum ViewByType {
  NO='NÃO VISUALIZADO',
  CONTRACT='CONTRACT',
  CUSTOMER='CUSTOMER',
  PHYSICIAN='PHYSICIAN'
}